import Home from '@/pages/home';
import LinzhiIntro from '@/pages/linzhitaohua2022/intro';
// import LinzhiWay from '@/pages/linzhitaohua2022/way';
import PageEr404 from '@/pages/pageEr404';

const routeList = [
    { 
        text: '720yun奖项活动',
        path: '/activity/',
        exact: true, 
        render(props){
            return <Home title="720yun奖项活动" {...props}/>
        } 
    },
    { 
        text: '2022林芝桃花VR全景游大赛-介绍',
        path: '/activity/linzhitaohua2022/intro',
        exact: true, 
        render(props){
            return <LinzhiIntro title="2022林芝桃花VR全景游大赛-介绍" {...props}/>
        } 
    },
    // { 
    //     text: '2022林芝桃花VR全景游大赛-参赛方式',
    //     path: '/activity/linzhitaohua2022/way',
    //     exact: true, 
    //     render(props){
    //         return <LinzhiWay title="2022林芝桃花VR全景游大赛-参赛方式" {...props}/>
    //     } 
    // },
    { 
        text: '720yun·404',
        path: '/activity/pageEr404',
        exact: true, 
        render(props){
            return <PageEr404 title="720yun·404" {...props}/>
        } 
    },
]

export {routeList}